function getEnv(name) {
  return window.configs && window.configs[name]
    ? window.configs[name]
    : process.env[name]
}

export { getEnv }
